import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import ProjectCardItem from "../../../components/Card/ProjectCardItem";
import { TableGeneral } from "../../../components/table/TableGeneral";
import { ModalDeleteProject } from "./components/ModalDeleteProject";
import CardProject from "../../../components/Card/CardDetailProject";
import TableProject from "../new-project/components/TableProject";
import { CardTable } from "../../../components/Card/CardTable";
import { MessageAnt } from "../../../redux/slices/ui/uiAction";
import { elipses, circles } from "../new-project/indexAssets";
import { MessageType } from "../../../types/messageType";
import useTableProjects from "./hooks/useTableProjects";
import useYear from "../../../hooks/Year";


export const PageTableProjectClient = () => {
    const [searchParams] = useSearchParams();
    const auth = useSelector((state) => state.auth);
    const { listOfYears, updateYear, year } = useYear(5);
    const {
        cardData,
        isLoading,
        projects,
        columns,
        modalDeleteProyect,
        updateProjects,
        updateCards,
        updateModalDelete
    } = useTableProjects();

    useEffect(() => {
        if (!auth.authentication) return
        updateProjects(searchParams.get("own"), year, auth);
    }, [year, updateProjects, searchParams, auth]);

    /**
     * @param {string} extra.action - The action performed (paginate | sort | filter).
     */
    const onChangeTable = (pagination, filters, sorter, extra = { action: "", currentDataSource: [] }) => {
        const { action, currentDataSource } = extra;
        if (action === "filter") {
            updateCards({ filters, projectsFilter: currentDataSource, auth });
        }
    };

    return (
        <div className="h-[90vh] w-full flex flex-col p-4  ">
            <div className="w-full flex flex-wrap justify-center  gap-4 ">
                <div className="h-36">
                    <div className="w-[328px] md:w-[384px] xl:w-[384px] h-full  ">
                        <CardProject title="Porcentaje del proyectos" titleClass="text-xs">
                            <ProjectCardItem
                                key={`percentage of Satisfactorio`}
                                elipseImage={elipses.elipseGreen}
                                value={cardData.progress}
                                label="0%-69%"
                                typeOfData="Satisfactorio"
                            />
                            <ProjectCardItem
                                key={`percentage of Ideal`}
                                elipseImage={elipses.elipseYellow}
                                value={cardData.acceptable}
                                label="70%-100%"
                                typeOfData="Ideal"
                            />
                            <ProjectCardItem
                                key={`percentage of Excedido`}
                                elipseImage={elipses.elipseOrange}
                                value={cardData.attention}
                                label="101%-115%"
                                typeOfData="Excedido"
                            />
                            <ProjectCardItem
                                key={`percentage of Peligro`}
                                elipseImage={elipses.elipseRed}
                                value={cardData.extended}
                                label=">115%"
                                typeOfData="Peligro"
                            />
                            <ProjectCardItem
                                key={`percentage of Desbordado`}
                                elipseImage={elipses.elipsePurple}
                                value={cardData.overflow}
                                label=">200%"
                                typeOfData="Desbordado"
                            />
                        </CardProject>
                    </div>
                </div>
                <div className="h-36">
                    <div className="w-[328px] md:w-[312px] xl:w-[312px]   h-full  flex justify-center ">
                        <CardProject title="Estado" titleClass="text-xs">
                            <div className="flex justify-center w-full">
                                <ProjectCardItem
                                    key={"number of Concluido project"}
                                    elipseImage={circles.circleBlue}
                                    value={cardData.ACTIVO}
                                    typeOfData="Activo"
                                />
                                <ProjectCardItem
                                    key={"number of Activo project"}
                                    elipseImage={circles.circlePurple}
                                    value={cardData.PAUSA}
                                    typeOfData="Pausa"
                                />
                                <ProjectCardItem
                                    key={"number of Pausa project"}
                                    elipseImage={circles.circleGreen}
                                    value={cardData.CONCLUIDO}
                                    typeOfData="Concluido"
                                />
                                <ProjectCardItem
                                    key={"number of Cancelado project"}
                                    elipseImage={circles.circleRed}
                                    value={cardData.CANCELADO}
                                    typeOfData="Cancelado"
                                />
                            </div>
                        </CardProject>
                    </div>
                </div>
                <div className="h-36">
                    <div className="w-[328px] md:w-[309px] xl:w-[309px]  h-full flex justify-center ">
                        <CardProject title="Total de horas de los proyectos por año" titleClass="text-xs">
                            <TableProject hoursBudget={cardData.budgetHours} hoursWorked={cardData.workedHours} />
                        </CardProject>
                    </div>
                </div>
            </div>

            <div className="w-full pt-4 grow    ">
                <CardTable title="Clasificación de proyectos" currentValue={year} listValues={listOfYears} updateValue={updateYear}>
                    <TableGeneral
                        loading={isLoading}
                        column={columns}
                        state={projects}
                        tableProps={{
                            sticky: true,
                            onChange: onChangeTable,
                        }}
                    />
                </CardTable>
            </div>
            <ModalDeleteProject
                modalDeleteProyect={modalDeleteProyect}
                updateResponse={() => {
                    MessageAnt(MessageType.success, "Proyecto actualizado correctamente");
                    updateProjects(searchParams.get("own"), year, auth);
                }}
                closeModal={() => {
                    updateModalDelete({ active: false, clickupSpace: "" })
                }}
            />
        </div>
    );
};
